(function () {

    var $htmlBody = $("html, body");
    var headerHeight = 0;
    var id = "";

    function calcHeaderHeight() {
        if (!$(".header__title").is(":visible")) {
            headerHeight = $(".header").outerHeight(true);
        } else {
            headerHeight = $(".header__top").outerHeight(true) +
                $(".header__title").outerHeight(true) - 1;
        }
    }

    function scrollToSection() {
        if ($(id).length) {
            var top = $(id).offset().top;

            $htmlBody.animate({
                scrollTop : top - headerHeight
            }, 700);

        } else {
            console.log("id element is not exist");
        }
    }

    function scrollToSectionContent() {
        if ($(id).length) {
            var top = $(id).offset().top;
            var cardHeaderHeight = $(id).find('.card-header').height();

            $htmlBody.animate({
                scrollTop : top - headerHeight
            }, 700);

        } else {
            console.log("id element is not exist");
        }
    }

    $("a[href*='#']").on("click", function (e) {
        var $a = $(e.currentTarget);
        id = $a.attr("href");

        $(".header__bottom").collapse("hide");

        calcHeaderHeight();

        if ($a.parents(".sembcorp-carousel").length && id === "#sustainable-future" ||
            $a.parents(".header__top").length && id === "#download-centre") {

            var target = id + "-target";
            if ( $("[data-target='"+target+"']").attr("aria-expanded") === "false") {
                $(target).collapse("show");

                // wait for others collapse then started to calc the section offset top
                setTimeout(function () {
                    scrollToSectionContent();
                }, 300);

            } else {
                scrollToSection();
            }
    
        } else {
            scrollToSection();
        }

        e.preventDefault();
    });

})();